module.exports = function (isMobile, locale) {
  return {
    navList: [{
      name: 'パワーシステム',
      imgSrc: isMobile ? ['solutions_nav_mm100_h5.webp', 'solutions_nav_mm100_h5.jpg'] : ['solutions_nav_mm100.webp', 'solutions_nav_mm100.jpg'],
      detLink: "/".concat(locale, "/ecoflow-power-kits/series")
    }, {
      name: 'パワーシステム一覧',
      icons: '',
      detLink: "https://".concat(locale, ".ecoflow.com/collections/power-kits-components")
    }, {
      name: '蓄電容量の選び方',
      icons: '',
      detLink: "/".concat(locale, "/calculators/power-kits"),
      target: '_blank'
    }],
    content: {
      headerData: [{
        type: 'large',
        name: 'EcoFlow パワーシステム',
        desc: 'シンプル、スマート、コンパクトな次世代RV & オフグリッドシステム',
        imgSrc: isMobile ? ['solutions_bg_h5.webp', 'solutions_bg_h5.jpg'] : ['solutions_bg.webp', 'solutions_bg.jpg'],
        detLink: "/".concat(locale, "/ecoflow-power-kits/series")
      }],
      contextList: [{
        type: 'small',
        name: 'EcoFlow パワーハブ',
        desc: '5つのモジュールがこれ1つに',
        imgSrc: isMobile ? ['solutions_list1_h5.webp', 'solutions_list1_h5.jpg'] : ['solutions_list1.webp', 'solutions_list1.jpg'],
        imgHoverSrc: ['solutions_list1_hover.webp', 'solutions_list1_hover.jpg'],
        detLink: "https://".concat(locale, ".ecoflow.com/products/power-hub")
      }, {
        type: 'small',
        name: 'EcoFlow パワーシステム専用LFPバッテリー',
        desc: 'バッテリー容量2～15kWhから選べる',
        imgSrc: isMobile ? ['solutions_list2_h5.webp', 'solutions_list2_h5.jpg'] : ['solutions_list2.webp', 'solutions_list2.jpg'],
        imgHoverSrc: ['solutions_list2_hover.webp', 'solutions_list2_hover.jpg'],
        detLink: "https://".concat(locale, ".ecoflow.com/products/lfp-battery")
      }, {
        type: 'small',
        name: 'EcoFlow パワーシステム専用スマート分電盤',
        desc: '最大6つのAC回路と12のDC回路を接続可',
        imgSrc: isMobile ? ['solutions_list3_h5.webp', 'solutions_list3_h5.jpg'] : ['solutions_list3.webp', 'solutions_list3.jpg'],
        imgHoverSrc: ['solutions_list3_hover.webp', 'solutions_list3_hover.jpg'],
        detLink: "https://".concat(locale, ".ecoflow.com/products/ac-dc-smart-distribution-panel")
      }, {
        type: 'small',
        name: 'パワーシステム専用\nタッチパネルモニター',
        desc: '電力ステータスをラクラク監視・設定',
        imgSrc: isMobile ? ['solutions_list4_h5.webp', 'solutions_list4_h5.jpg'] : ['solutions_list4.webp', 'solutions_list4.jpg'],
        imgHoverSrc: ['solutions_list4_hover.webp', 'solutions_list4_hover.jpg'],
        detLink: "https://".concat(locale, ".ecoflow.com/products/power-kits-console")
      }]
    }
  };
};